module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "invoice"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v("寄送信息")]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("地址名称")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.express.name || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.express.contact || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.express.phone || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.express.address || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("邮政编号")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.express.zipCode || '空'))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61dcea38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/invoice/customer-express.vue
// module id = 1288
// module chunks = 82